import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import EditBack from '../../components/common/EditBack';
import REPLoadsAwaitingReturnList from '../../components/rts/Analytics/REPLoadsAwaitingReturnList';

import { useSessionContext } from '../../contexts/SessionContext';

export default function REPLoadsAwaitingReturnPage( props ){
    //console.debug("RTS Break REPLoadsAwaitingReturnPage");

    const {sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [data, setData] = useState([]);

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const fetchData = useCallback(() => {
        let apiURL = apiRoot + "/Analytics/GetLoadsAwaitingReturn";
        axios
        .post(
            apiURL,
            sessionCustomer.customer,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token}}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token, sessionCustomer.customer]);

  
    useEffect(() => {
        props.setIsModalFx(false);
        fetchData();
    }, [props, fetchData]);

    
    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '80vh';
        }
        return retValue;
    }  

    
    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <Box id="pageBox">
            <Box sx={{my:2, width:'100%', display:'flex', justifyContent:'start', alignContent:'center'}}>
                <EditBack />
                <Typography variant="h5" >Reels Awaiting Return</Typography>
            </Box>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <REPLoadsAwaitingReturnList data={data} />
            </Box>            
        </Box>
    );    
}
